@if(isLoaderOn){
<div class="spinner-container">
    <mat-spinner diameter="40"></mat-spinner>
</div>
}